import { Component, OnInit } from '@angular/core';
import { SharedDataService } from "../shared-data.service";
import { Router } from '@angular/router';
import { ApiOpenmindService } from '../apiopenmind.service';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.css']
})
export class UserDetailComponent implements OnInit {


  public objUser: any;

  constructor(private router: Router, private sharedData: SharedDataService, private apiopenmindservice: ApiOpenmindService) {
    this.objUser = [];
  }

  ngOnInit() {
    this.loadUser();
  }

  loadUser() {
    let userId = sessionStorage.getItem("userEditId");
    this.apiopenmindservice.GetUserById(userId).toPromise().then(x => {
      if (x != null && x != "") {
        this.objUser = x;
      }
      else {
        console.log("Error trayendo la data del usuario con Id" + userId);
      }
    });
  }

  saveProfile() {
    if (this.objUser == null)
      return;
    this.apiopenmindservice.SaveUser(this.objUser).subscribe(event => console.log(event));
    console.log(this.objUser.username);
  }

}
